module.exports = __webpack_public_path__ + "img/edit.be3c2a47.svg";